<p-toast [baseZIndex]="10000"></p-toast>
@if (isLoading) {
  <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
} @else if(!isLoading && !isError) {
  <div [@fadeIn]="true">
    <div class="d-flex justify-content-center scroll min-height">
      <div class="row col-10">
        <p-fieldset legend="{{ 'Administration.Data Cleanup Log.Title' | translate }}">
          <p-card class="d-block mx-6 my-6" >
            <div class="my-3 mx-4">
              <p-table #cleanupLogTable [value]="cleanupLogs"
                       [multiSortMeta]="[{field: 'executeTimeAux', order: -1}, {field: 'customerName', order: 1}, {field: 'countries', order: -1}, {field: 'periodFrom', order: -1}]"
                       sortMode="multiple" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50]"
                       [globalFilterFields]="['customerName', 'countries', 'status', 'periodFrom', 'periodTo', 'executeTimeAux']">

                <ng-template pTemplate="header">
                  <tr class="header">
                    <th class="px-0" pSortableColumn="customerName"    translate> Common.Customer     <p-sortIcon field="customerName">   </p-sortIcon> </th>
                    <th class="px-0" pSortableColumn="countries"       translate> Common.Country      <p-sortIcon field="countries">     </p-sortIcon> </th>
                    <th class="px-0" pSortableColumn="status"          translate> Common.Status       <p-sortIcon field="status">      </p-sortIcon> </th>
                    <th class="px-0" pSortableColumn="periodFrom"      translate> Common.Period From  <p-sortIcon field="periodFrom">  </p-sortIcon> </th>
                    <th class="px-0" pSortableColumn="periodTo"        translate> Common.Period To    <p-sortIcon field="periodTo">    </p-sortIcon> </th>
                    <th class="px-0" pSortableColumn="executeTimeAux"  translate> Common.Execute Time <p-sortIcon field="executeTimeAux"> </p-sortIcon> </th>
                  </tr>
                  <tr>
                    <th> <p-columnFilter type="text" field="customerName">    </p-columnFilter> </th>
                    <th> <p-columnFilter type="text" field="countries">       </p-columnFilter> </th>
                    <th> <p-columnFilter type="text" field="status">          </p-columnFilter> </th>
                    <th> <p-columnFilter type="text" field="periodFrom">      </p-columnFilter> </th>
                    <th> <p-columnFilter type="text" field="periodTo">        </p-columnFilter> </th>
                    <th> <p-columnFilter type="text" field="executeTimeAux">  </p-columnFilter> </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-cleanup let-expanded="expanded">
                  <tr [pContextMenuRow]="cleanup" class="row-data">
                    <td> {{ cleanup.customerName }}           </td>
                    <td> {{ cleanup.countries }}              </td>
                    <td> {{ cleanup.status }}                 </td>
                    <td> {{ cleanup.periodFrom }}             </td>
                    <td> {{ cleanup.periodTo }}               </td>
                    <td> {{ cleanup.executeTimeAux }} </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="9" translate> Table Commons.Not Found </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft"> </ng-template>
              </p-table>
            </div>
          </p-card>
        </p-fieldset>
      </div>
    </div>
  </div>
}
